import adBlockDetect from './adBlockDetect.js';
export default adBlockDetect;